import { ConvexProvider, ConvexReactClient } from "convex/react";
import { AgentForm } from "./AgentForm";
import { PasswordProtection } from "./PasswordProtection";
import swoop from "./swoop.svg";
import "./index.css";

const convex = new ConvexReactClient(process.env.BUN_PUBLIC_CONVEX_URL || "");

export function App() {
  return (
    <ConvexProvider client={convex}>
      <PasswordProtection>
        <img
          src={swoop}
          alt=""
          aria-hidden
          className="fixed-bg-image"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            pointerEvents: "none",
            zIndex: -1,
          }}
        />
        <AgentForm />
      </PasswordProtection>
    </ConvexProvider>
  );
}

export default App;
